import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Label } from '../KeyComponents';
import InlineDropdown from '../InlineDropdown';
import countryCodes from './data/courtryCodes';

function TextInputPhoneNumber(props) {
  const {
    label,
    state,
    placeholder,
    value,
    size,
    required,
    name,
    className,
    onChange: onChangeHandler,
    contryCodeChangeHandler,
    selectedCountryCode,
  } = props;

  // Find the country code object that matches the selected dial code
  const selectedCountry = countryCodes.find(country => country.dial_code === selectedCountryCode);

  return (
    <div className={classNames('pgn__text-input-ph-no-wrapper', { 'pgn__text-input-ph-no-wrapper-filled': value !== '' }, `pgn__text-input-ph-no-wrapper-${size}`, `pgn__text-input-ph-no-wrapper-${state}`, className)}>
      {label && <Label label={label} required={required} />}
      <div className="pgn__text-input-ph-no-body">
        <div className="pgn__text-input-ph-no-body-left">
          <InlineDropdown
            disabled={state === 'disabled'}
            className="pgn__text-input-ph-no-body-left-dropdown"
            placeholder="Select"
            bodyClassName="pgn__text-input-ph-no-body-left-dropdown-body"
            onSelect={(selected) => contryCodeChangeHandler(selected)}
            selected={selectedCountryCode}
          >
            {countryCodes.sort((a, b) => parseInt(a.dial_code, 10) - parseInt(b.dial_code, 10)).map((country) => (
              <InlineDropdown.Item
                key={country.code}
                label={country.dial_code}
                value={country.dial_code}
                flag={country.code.toLowerCase()}
                selected={country.dial_code === selectedCountryCode}
              />
            ))}
          </InlineDropdown>
        </div>

        <input className="pgn__text-input-field" type="number" placeholder={placeholder} value={value} onChange={(e) => onChangeHandler(e.target.value)} name={name} disabled={state === 'disabled'} />

        <div className="pgn__text-input-ph-no-body-right" />
      </div>
    </div>
  );
}

TextInputPhoneNumber.defaultProps = {
  size: 'md',
  state: 'default',
  label: '',
  required: false,
  placeholder: 'Enter text here',
  value: '',
  className: '',
  selectedCountryCode: '',
};

TextInputPhoneNumber.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  state: PropTypes.oneOf(['default', 'error', 'disabled']),
  label: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  contryCodeChangeHandler: PropTypes.func.isRequired,
  selectedCountryCode: PropTypes.string,
};

export default TextInputPhoneNumber;
